import { lazy } from "react";

const AutopayMandatePage = lazy(() =>
  import("../Component/AutopayMandate/AutopayMandatePage"),
);

const autopayRoutes = [
  { path: "/autopay-mandate", element: <AutopayMandatePage />, protected: true },
];

export default autopayRoutes;
